import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import {
  TRANSIENT_TRANSACTION_STATUSES,
  type TransactionDto,
} from "@/features/wallet/api/dto";

/** Cadence de rafraîchissement du suivi de statut (§5.3). */
const POLLING_INTERVAL_MS = 5000;

/**
 * Détail / reçu d'une transaction (`GET /Transactions/{id}`).
 *
 * Suivi de statut (flux §5.3) : tant que le statut est transitoire
 * (PENDING, AWAITING_LEDGER — la transaction attend l'écriture comptable
 * puis confirm-ledger), la query est re-polée toutes les 5 s ; un statut
 * final (COMPLETED, FAILED, REVERSED) arrête le polling.
 */
export const useTransaction = (transactionId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_TRANSACTION_DETAIL(transactionId),
    queryFn: () =>
      fetchDataGet<TransactionDto>({
        url: walletEndpoints.transactions.detail(transactionId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(transactionId),
    refetchInterval: (query) =>
      query.state.data &&
      TRANSIENT_TRANSACTION_STATUSES.includes(query.state.data.status)
        ? POLLING_INTERVAL_MS
        : false,
  });
